<template>
  <div class="sidebar-position-detail-map-view">
    <div
      class="sidebar-position-detail-map-view__top"
      :style="{
        'background-color': this.activePosition.gemeente.app_asset
          ? this.activePosition.gemeente.app_asset.color_primary
          : null
      }"
    >
      <div class="sidebar-position-detail-map-view__top__left">
        <svg svg-inline="" @click="openSidebarPositionDetailIndex" class="sidebar-position-detail-map-view__top__left__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
        <div class="sidebar-position-detail-map-view__top__left__text">
          {{ activePosition.address }}
        </div>
      </div>
      <div class="sidebar-position-detail-map-view__top__right">
        <svg svg-inline="" @click="openSidebarPositionDetailIndex" class="sidebar-position-detail-map-view__top__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M2 5h3v3H2zM2 11h3v3H2zM2 17h3v3H2zM8 5h14v3H8zM8 11h14v3H8zM8 17h14v3H8z"/></g></svg>
      </div>
    </div>

    <div class="sidebar-position-detail-map-view__map">
      <MapViewMaps :active-position="activePosition"></MapViewMaps>
    </div>

    <template v-if="polygonFeaturesLength">
      <div class="sidebar-position-detail-map-view__bottom">
        <SidebarListItem
          @click.native="openSidebarPositionDetailIndexPolygon"
          :gebiedsmeldingicon="true"
        >
          <div class="sidebar-list-item__left">
            <div
              class="sidebar-list-item__left__icon-container"
              :style="{
                'background-color': activePosition.gemeente.app_asset
                  ? activePosition.gemeente.app_asset.color_primary
                  : null
              }"
            >
              <img
                svg-inline
                src="../../assets/ic/icons/ic_notifications_nb.png"
                class="sidebar-list-item__left__icon-container__icon"
              />
            </div>
          </div>
          <div class="sidebar-list-item__middle">
            <div class="sidebar-list-item__middle__text-title">
              Gebiedsmeldingen
            </div>
            <div
              class="sidebar-list-item__middle__text-subtitle bigger-subtitle"
            >
              In totaal {{ polygonFeaturesLength }}
              {{ polygonFeaturesLength == 1 ? "melding" : "meldingen" }} die
              geen specifieke locatie
              {{ polygonFeaturesLength == 1 ? "heeft" : "hebben" }} maar wel in
              de omgeving van je locatie
              {{ polygonFeaturesLength == 1 ? "ligt" : "liggen" }}
            </div>
          </div>
          <div class="sidebar-list-item__right">
            <svg svg-inline="" class="sidebar-list-item__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-180 13 12)" d="M18 4.462L16.603 3 8 12l8.603 9L18 19.538 10.795 12z"/></g></svg>
          </div>
        </SidebarListItem>
      </div>
    </template>
  </div>
</template>

<script>
import SidebarListItem from "@/components/SidebarListItem";
import MapViewMaps from "@/components/Position/MapViewMaps";

export default {
  components: {
    SidebarListItem,
    MapViewMaps
  },
  computed: {
    activePosition() {
      return this.$store.state.ui.activePosition;
    },
    polygonFeatures() {
      return this.$store.state.ui.polygonFeatures;
    },
    polygonFeaturesLength() {
      return this.polygonFeatures.length;
    }
  },
  methods: {
    openSidebarPositionDetailIndex() {
      this.$store.commit("closeSidebarPositionDetailMapView");
      this.$store.commit("openSidebarPositionDetailIndex");
    },
    openSidebarPositionDetailIndexPolygon() {
      this.$store.commit("setActiveFeature", this.polygonFeatures[0]);
      this.$store.commit("setReadFeatures", this.polygonFeatures[0]);
      this.$store.commit("closeSidebarPositionDetailIndex");
      this.$store.commit("openSidebarPositionDetailIndexPolygon");
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-detail-map-view {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  box-shadow: 2px 4px 10px 0 rgba(0, 0, 0, 0.05);

  &__top {
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: $spacing-3;
    background: $color-green-1;

    &__left {
      display: flex;
      align-items: center;
      width: calc(100% - 52px);

      &__icon {
        display: inline-block;
        position: relative;
        top: 1px;
        cursor: pointer;
        left: -6px;

        path {
          fill: #fff;
        }
      }
      &__text {
        display: inline-block;
        @extend %text-large;
        color: #fff;
        padding: 0 $spacing-2 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__right {
      margin-left: auto;
      margin-right: $spacing-3;

      &__icon {
        background-size: 24px 24px;
        width: 24px;
        height: 24px;
        border: 0;
        cursor: pointer;

        path {
          fill: #fff;
        }
      }
    }
  }

  &__map {
    display: flex;
    flex: 1;
  }
  &__bottom {
    margin-top: auto;
    display: flex;
  }
}
</style>
